import { render } from "./PlotsPage.vue?vue&type=template&id=342ea440&scoped=true&ts=true"
import script from "./PlotsPage.vue?vue&type=script&lang=ts"
export * from "./PlotsPage.vue?vue&type=script&lang=ts"

import "./PlotsPage.vue?vue&type=style&index=0&id=342ea440&scoped=true&lang=css"

import exportComponent from "/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-342ea440"]])

export default __exports__